import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import { SR_API_ACTION_PROPERTY_ATTRIBUTE_UPSERT } from 'api/actionTypes';

import {
  PROPERTY_ATTRIBUTE_CATEGORY_FEATURE,
  PROPERTY_ATTRIBUTE_CASCADING_BEHAVIOR_NEITHER,
  PROPERTY_ATTRIBUTE_LEVEL_APARTMENT,
  PROPERTY_ATTRIBUTE_LEVEL_APARTMENT_BUILDING,
  PROPERTY_ATTRIBUTE_LEVEL_FLOOR_PLAN,
} from 'common/propertyAttributeConstants';

import { createInitialValues, createFormValidationFn } from 'client/helpers/formikHelpers';

import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';
import SrIcon from 'client/components/SrIcon';
import SrFormikField, {
  SR_FIELD_THEME_ADMIN,
  SR_FIELD_THEME_LONG_TEXTAREA,
} from 'client/components/SrFormikField';
import SrDarkModal from 'client/components/SrDarkModal';
import SrModalContent from 'client/components/SrModalContent';
import ButtonDeprecated from 'client/components/ButtonDeprecated';

import postWithState from 'client/actions/postWithState';

function getPropertyAttributeFeatureFormFields({ propertyAttribute, propertyAttributeLevel }) {
  return [
    {
      id: propertyAttributeLevel,
      type: 'long_text',
      title: 'description',
      validations: !propertyAttribute ? ['required'] : [],
    },
  ];
}

class SrPropertyAttributeFeatureModal extends Component {
  static propTypes = {
    propertyAttributes: PropTypes.array.isRequired,
    apartmentId: PropTypes.number.isRequired,
    apartmentBuildingId: PropTypes.number,
    floorPlanId: PropTypes.number,
    propertyAttributeLevel: PropTypes.oneOf([
      PROPERTY_ATTRIBUTE_LEVEL_APARTMENT,
      PROPERTY_ATTRIBUTE_LEVEL_APARTMENT_BUILDING,
      PROPERTY_ATTRIBUTE_LEVEL_FLOOR_PLAN,
    ]),
    onClose: PropTypes.func.isRequired,
  };

  _onSubmitForm = (formValues) => {
    const {
      propertyAttributes,
      apartmentId,
      apartmentBuildingId,
      floorPlanId,
      propertyAttributeLevel,
      onChange,
      dispatch,
    } = this.props;

    const propertyAttribute = propertyAttributes.find(
      ({ name }) => name === propertyAttributeLevel,
    );

    dispatch(postWithState, {
      action: SR_API_ACTION_PROPERTY_ATTRIBUTE_UPSERT,
      payload: {
        id: propertyAttribute ? propertyAttribute.id : undefined,
        apartmentId,
        apartmentBuildingId,
        floorPlanId,
        category: PROPERTY_ATTRIBUTE_CATEGORY_FEATURE,
        cascadingBehavior: PROPERTY_ATTRIBUTE_CASCADING_BEHAVIOR_NEITHER,
        name: propertyAttributeLevel,
        attrs: {
          value: formValues[propertyAttributeLevel],
        },
      },
    }).then(onChange);
  };

  render() {
    const { propertyAttributes, propertyAttributeLevel, onClose } = this.props;

    const propertyAttribute = propertyAttributes.find(
      ({ name }) => name === propertyAttributeLevel,
    );
    const propertyAttributeFeatureFormFields = getPropertyAttributeFeatureFormFields({
      propertyAttribute,
      propertyAttributeLevel,
    });

    return (
      <SrDarkModal>
        <SrModalContent style={{ maxWidth: 440, height: 500, marginTop: 90, overflow: 'visible' }}>
          <SrBox top={-40} left={-40} position="absolute" onClick={onClose} zIndex={1000}>
            <SrIcon className="x-close-large-white" />
          </SrBox>
          <SrFlex justify="center">
            <SrText size="2xl" align="center" font="whitney-sc">
              property feature
            </SrText>
          </SrFlex>
          <Formik
            initialValues={createInitialValues({
              formFields: propertyAttributeFeatureFormFields,
              defaultValues: propertyAttributes.reduce(
                (memo, propertyFeature) => ({
                  ...memo,
                  [propertyFeature.name]: propertyFeature.attrs.value,
                }),
                {},
              ),
            })}
            validate={createFormValidationFn(propertyAttributeFeatureFormFields)}
            onSubmit={this._onSubmitForm}
            render={(formikBag) => {
              return (
                <Form>
                  {propertyAttributeFeatureFormFields.map((formField) => (
                    <SrFormikField
                      key={formField.id}
                      formField={formField}
                      formikBag={formikBag}
                      className={`${SR_FIELD_THEME_ADMIN} ${SR_FIELD_THEME_LONG_TEXTAREA}`}
                    />
                  ))}
                  <SrBox marginTop={20}>
                    <ButtonDeprecated type="submit" disabled={!formikBag.isValid}>
                      {propertyAttribute ? 'update' : 'create'}
                    </ButtonDeprecated>
                  </SrBox>
                </Form>
              );
            }}
          />
        </SrModalContent>
      </SrDarkModal>
    );
  }
}

SrPropertyAttributeFeatureModal.displayName = 'SrPropertyAttributeFeatureModal';

export default SrPropertyAttributeFeatureModal;
